/**
 * FPR Player Item Component
 * 
 * FP Race specific component for displaying a player in a round.
 * Simpler than HNS - no roles, DQ, or capture status.
 */

import { memo } from 'react';
import {
  RoundPlayer,
  Player,
  getPlayerDisplayName,
} from '@swtorbit/shared-socket-events';

interface FprPlayerItemProps {
  player: RoundPlayer;
  gamePlayers: Player[];
}

export const FprPlayerItem = memo(function FprPlayerItem({
  player,
  gamePlayers,
}: FprPlayerItemProps) {
  return (
    <div className="fpr-player">
      <span>{getPlayerDisplayName(player.playerId, gamePlayers)}</span>
    </div>
  );
});
